import type { DocumentUploadFieldProps } from "./document-upload-field.type";

import { useTranslation } from "react-i18next";

import UploadFile from "@/modules/upload-file";
import UploadFormItem from "@/modules/upload-form-item";

import { convertDocumentToUploadExistingFile } from "./document-upload-field.helper";

const DocumentUploadField = ({
  document,
  uploadProps,
  ...fieldProps
}: DocumentUploadFieldProps) => {
  const { t } = useTranslation();

  const file = convertDocumentToUploadExistingFile(document);
  const defaultFileList = file ? [file] : [];

  return (
    <UploadFormItem
      name="document"
      label={t("global:document")}
      {...fieldProps}
    >
      <UploadFile
        {...uploadProps}
        multiple={false}
        maxCount={1}
        defaultFileList={defaultFileList}
      />
    </UploadFormItem>
  );
};

export default DocumentUploadField;
